module.exports = __webpack_public_path__ + "static/media/outlet.8f462527.svg";